import { LLT_DOWNLOADED, LLT_FAILED, LLT_PENDING } from './types';
import LongLocationTypeApiService from '../../services/api/LongLocationTypeApiService';
import { handleError } from '../infos/actions';

export const lltsPendingAction = () => (
  {
    type: LLT_PENDING,
  }
);

export const lltsFailedAction = (error) => (
  {
    type: LLT_FAILED,
    payload: error,
  }
);

export const lltsDownloadedAction = (llts) => (
  {
    type: LLT_DOWNLOADED,
    payload: llts,
  }
);

export function getLongLocationTypes(token) {
  return (dispatch) => {
    dispatch(lltsPendingAction());
    return LongLocationTypeApiService
      .getLongLocationTypes(token)
      .then(data => {
        dispatch(lltsDownloadedAction(data));
        return data;
      })
      .catch(error => {
        dispatch(lltsFailedAction(error));
        dispatch(handleError(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/longLocationDurations/actions.js